import React from 'react';
interface MicroCTAProps {
  text: string;
  href: string;
  className?: string;
}
export function MicroCTA({
  text,
  href,
  className = ''
}: MicroCTAProps) {
  return <div className={className} data-id="element-376">
      <a href={href} className="text-[#2e7d32] hover:text-[#1b5e20] font-medium text-sm inline-flex items-center" data-id="element-377">
        {text}
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-378">
          <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" data-id="element-379" />
        </svg>
      </a>
    </div>;
}